import React from 'react'
import { IDailySale } from '../types/trend-product'
import { ProductLoading, useProducts } from '@/features/products'
import ProductSlide from './product-slide'
interface FlashSaleProductProps {
  sale?: IDailySale
  isLoading?: boolean
}
export default function PanelProductsSale({ sale, isLoading }: FlashSaleProductProps) {
  if (isLoading) {
    return <ProductLoading itemCount={4} showPagination={false} />
  }
  return (
    <ProductSlide
      classSwiper="swiper-sale-product"
      productsSale={sale?.items}
      slidesPc={4}
      slidesTablet={3}
      slidesMobile={1.5}
    />
  )
}
